<div [class]="{ header: true, 'header-left-panel': isLeftEditPanel$ | async }">
  <div class="title-container">
    <mat-icon class="icon" [svgIcon]="icon$ | async"></mat-icon>
    <span class="overline title">{{ title$ | async | uppercase }}</span>
  </div>

  <div class="dimensions-chip body-03">
    @let dimensions = (dimensions$ | async) || [0, 0];
    <span
      [class]="{
        'dimension-highlight': shouldHighlightWidthDimension$ | async,
      }"
      >W {{ dimensions[0] }}</span
    >
    <span>x</span>
    <span
      [class]="{
        'dimension-highlight': shouldHighlightHeightDimension$ | async,
      }"
      >H {{ dimensions[1] }}</span
    >
  </div>
</div>
